import React, { memo, useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import ButtonCustom from "../../../../UIcomponentsRedesign/ButtonCustom/ButtonCustom";
import SpinnerMain from "../../../../UIcomponentsRedesign/SpinnerMain";
import AskDocModal from "../../../../app/components/ask-doc-modal/AskDocModal";
import ErrorModal from "../../../../app/components/error-modal/ErrorModal";
import useIsMobile from "../../../../core/hooks/useIsMobile";
import leadsService from "../../../../core/services/LeadsService";
import { editDocsCount } from "../../../../core/store/action-creators/countsData";
import { LeadDocPackType } from "../../../../core/types/leadsApiTypes";
import { downloadBlobFile } from "../../../../core/utils/downloadBlobFile";
import { useStyles } from "./DocumentsStyles";
const DocumentCard = React.lazy(() => import("./DocumentCard"));

type Props = {
  leadId: number;
  isArchive: boolean;
};

const DocumentsPartner: React.FC<Props> = ({
  leadId,
  isArchive,
}) => {
  const classes = useStyles();
  const isMobile = useIsMobile();
  const dispatch = useDispatch();
  const [error, setError] = useState<boolean>(false);
  const [docPacksList, setDocPacksList] = useState<LeadDocPackType[]>();
  const [requiredDocPacksList, setRequiredDocPacksList] = useState<LeadDocPackType[]>();
  const [notRequiredDocPacksList, setNotRequiredDocPacksList] = useState<LeadDocPackType[]>();
  const [renew, setRenew] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorModal, setErrorModal] = useState<boolean>(false);
  const [modals, setModals] = useState({
    isAskDocModal: false,
  });

  const handleErrorChange = (errorState: boolean | ((prevState: boolean) => boolean)) => {
    setError(errorState);
  };
  const fetchDocPacks = useCallback(async () => {
    try {
      const res = await leadsService.getLeadDocPacksService(leadId);
      if (res) {
        setDocPacksList(res);
        setRequiredDocPacksList(res.filter(doc => doc?.isRequired))
        setNotRequiredDocPacksList(res.filter(doc => !doc?.isRequired))
        const requiredDocsCount = res.filter(doc => doc?.isRequired).length;
        const noEmptyFileDocsCount = res.filter(doc => doc?.isRequired && (doc?.files?.length > 0)).length;
        const neededDocCount = requiredDocsCount - noEmptyFileDocsCount;
        dispatch(editDocsCount({
          leadId,
          countNeededDocs: neededDocCount,
          countUnreadMessage: 0,
          countUnreadNotifications: 0
        }));
      }
    } catch (error) {
      console.log(error);
      setErrorModal(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leadId]);

  useEffect(() => {
    if (leadId) {
      fetchDocPacks();
    }
  }, [leadId, renew, fetchDocPacks]);

  const downloadFile = (
    docId: number,
    fileName: string
  ) => {
    setIsLoading(true)
    leadsService.getDocFileService(docId)
      .then((res) => {
        setRenew(!renew);
        downloadBlobFile(res, fileName);
      })
      .catch((error) => {
        setErrorModal(true)
        console.error(error);
      })
      .finally(() => {
        setIsLoading(false)
      });
  };

  return (
    <div className={classes.docsContainer}>
      {docPacksList && docPacksList.length > 0 ? (
        <>
          {!isArchive ?
            <div className={classes.statusBox}>
              <div className={classes.descBox} style={{ gap: '4px' }}>
                <h4 className={classes.title}>
                  {"Запрос документов"}
                </h4>
                <span className={classes.text}>
                  {"Нужны дополнительные документы от клиента? Создайте запрос с помощью формы ниже"}
                </span>
              </div>
              <ButtonCustom
                color={isMobile ? "primary_w100" : "primary"}
                handleClick={() => setModals({ ...modals, isAskDocModal: true })}
                style={{ width: isMobile ? "100%" : "240px" }}>
                Запросить документы
              </ButtonCustom>
            </div> : null}
          {requiredDocPacksList && requiredDocPacksList.length > 0 && requiredDocPacksList.map((doc: LeadDocPackType) => (
            <DocumentCard
              key={doc.id}
              doc={doc}
              showButton={false}
              handleDownloadFile={downloadFile}
              currentLeadArchive={isArchive}
            />
          ))}

          {notRequiredDocPacksList && notRequiredDocPacksList.length > 0 &&
            <>
              <div className={`${classes.docsContainer} ${classes.docsMargin}`}>
                <h4 className={classes.title}>
                  {'Дополнительные документы'}
                </h4>
                <span className={classes.text}>
                  {'Увеличивают вероятность одобрения банком'}
                </span>
              </div>
              {notRequiredDocPacksList.map((doc: LeadDocPackType) => (
                <DocumentCard
                  key={doc.id}
                  doc={doc}
                  showButton={false}
                  handleDownloadFile={downloadFile}
                  currentLeadArchive={isArchive}
                />
              ))}
            </>}
        </>
      ) : (
        <SpinnerMain />
      )
      }
      {isLoading &&
        <SpinnerMain fixedPosition />
      }
      {errorModal && <ErrorModal isOpen={errorModal} />}

      {modals.isAskDocModal && (
        <AskDocModal
          leadId={leadId}
          handleClose={() => {
            setModals({ ...modals, isAskDocModal: false });
          }}
          open={modals.isAskDocModal}
          setRenew={setRenew}
          handleError={handleErrorChange}
        />
      )}
      {error && <ErrorModal isOpen={errorModal} />}
    </div>
  );
};

export default memo(DocumentsPartner);